import { combineReducers } from 'redux'
import { routerReducer as router } from 'react-router-redux'
import gridBackground from 'containers/GridBackground/modules/reducer'
import alert from 'containers/Alert/modules/reducer'
import auth from 'routes/Auth/modules/reducer'
import { reducerKey as authReducerKey } from 'routes/Auth'
import discovery from 'routes/Auth/routes/Discovery/modules/reducer'
import { reducerKey as discoveryReducerKey } from 'routes/Auth/routes/Discovery'

export const makeRootReducer = (asyncReducers) => {
  const appReducer = combineReducers({
    // Add sync reducers here
    gridBackground,
    alert,
    [authReducerKey]: auth,
    [discoveryReducerKey]: discovery,
    router,
    ...asyncReducers
  })

  const rootReducer = (state, action) => {
    if (action.type === 'RESET') {
      state = undefined
    }
    return appReducer(state, action)
  }

  return rootReducer
}

export const injectReducer = (store, { key, reducer }) => {
  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer



/** WEBPACK FOOTER **
 ** ./src/store/reducers.js
 **/